@if (view(); as details) {
    <pace-notification-detail-navigation
        [showPrevious]="showPrevious()"
        [showNext]="showNext()"
        (previousSelect)="onPreviousNotification()"
        (nextSelect)="onNextNotification()"
    ></pace-notification-detail-navigation>

    <div class="scroll-container safe-area-bottom" [@slide]="getAnimationData()">
        <!-- Header, with the status step button and the badge projected into its third column -->
        <div class="header card row mb-1 mt-3 mx-0 mx-lg-0 py-2 p-lg-0">
            <div class="col my-1">
                <pace-notification-detail-header
                    [header]="details.header"
                    (actionSelect)="onHeaderAction($event)"
                    (fieldActionSelect)="onHeaderFieldAction($event)"
                >
                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <pace-status-step-button
                                id="availableStatus"
                                class="float-end mb-3"
                                [stepButton]="details.stepButton"
                                (actionSelect)="onStatusStepAction($event)"
                            ></pace-status-step-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 offset-3 ps-0 d-none d-lg-block">
                            @if (details.header.userStatus) {
                                <fa-icon class="me-1" [icon]="faFlag"></fa-icon>
                            }
                            <span>{{ details.header.userStatus }}</span>
                        </div>
                        <div class="col-4 ms-auto d-none d-lg-block">
                            <pace-status-badge [badge]="details.header.badge"></pace-status-badge>
                        </div>
                    </div>
                </pace-notification-detail-header>
            </div>
        </div>

        <!-- Notification and pre-clarification long text -->
        <div class="row">
            <div class="col">
                <pace-notification-longtext class="my-2" paceCoreLink [longtext]="details.longtext">
                </pace-notification-longtext>
            </div>
        </div>

        <!-- Material or participant carousel -->
        <div class="row">
            <div class="col">
                <pace-notification-detail-carousel
                    #carousel
                    class="mb-2"
                    paceSwipe
                    [carousel]="details.carousel"
                    (swipeLeft)="carousel.showNextSlide()"
                    (swipeRight)="carousel.showPreviousSlide()"
                    (materialPickupSelect)="onMaterialPickup($event)"
                    (participantEmailSelect)="onParticipantEmail($event)"
                ></pace-notification-detail-carousel>
            </div>
        </div>

        <!-- Dialogs and external links -->
        <div class="row">
            <div class="col">
                <pace-notification-action-links
                    [actionLinks]="details.actionLinks"
                    (actionSelect)="onActionLinkSelect($event)"
                ></pace-notification-action-links>
            </div>
        </div>
    </div>

    <div class="fixed-bottom safe-area-bottom">
        <div class="d-lg-none d-flex justify-content-between bg-light">
            @if (bottomBarStepButton(); as stepButton) {
                <pace-status-step-button
                    id="availableStatusBottomBar"
                    [stepButton]="stepButton"
                    (actionSelect)="onStatusStepAction($event)"
                ></pace-status-step-button>
            }
        </div>
    </div>
}
